import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { memberRemindersApi } from 'src/Services/API';

const useFetchMemberReminders = (memberId: string | undefined) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-member-reminders', assetId, memberId],
    queryFn: async () => {
      if (!assetId || !memberId) throw new Error('No assetId/memberId provided');

      return (await memberRemindersApi.memberRemindersControllerFindForMember(assetId, memberId))
        .data;
    },
    enabled: !!assetId && !!memberId,
  });
};

export default useFetchMemberReminders;
